module.exports = __webpack_public_path__ + "static/download-52f736699fcd0dd829c45b768e0c15f9.png";